"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _goods = require("@/api/goods");
var _order = require("@/api/order");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['editItem'],
  data: function data() {
    return {
      loading: true,
      form: {
        order_id: 0,
        setmeal_id: 0,
        spec_id: 0
      },
      specName: '规格',
      setmealList: [],
      specList: [],
      setmealDate: {},
      dialogVisible: false,
      rules: {
        setmeal_id: [{
          required: true,
          message: '请选择套餐',
          trigger: 'blur'
        }],
        spec_id: [{
          required: true,
          message: '请选择规格',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.loading = true;
        this.getGoodsSetmealList();
      } else {
        this.$refs['ruleForm'].resetFields();
      }
    }
  },
  methods: {
    getGoodsSetmealList: function () {
      var _getGoodsSetmealList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('item', { ...this.editItem })
                this.form.order_id = this.editItem.id;
                this.form.setmeal_id = this.editItem.setmeal_id;
                _context.next = 4;
                return (0, _goods.getGoodsSetmealList)(this.editItem.goods_id);
              case 4:
                res = _context.sent;
                if (res.setmeal) {
                  this.setmealList = res.setmeal;
                  this.loading = false;
                }
                console.log('res', this.setmealList);
                this.getSpecList();
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getGoodsSetmealList() {
        return _getGoodsSetmealList2.apply(this, arguments);
      }
      return getGoodsSetmealList;
    }(),
    getSpecList: function getSpecList() {
      var _this = this;
      var setmeal = this.setmealList.filter(function (item) {
        return item.id == _this.form.setmeal_id;
      });
      this.setmealDate = setmeal.length ? setmeal[0] : {};
      this.specList = setmeal.length ? setmeal[0].spec : [];
      this.form.spec_id = this.specList[0] ? this.specList[0].id : '';
      // console.log('this.setmealDate', this.setmealDate)
      // console.log('this.specList', this.specList)
    },
    getSpecLable: function getSpecLable(item) {
      var spec = item.spec[0];
      var specsName = this.setmealDate.specs_name ? this.setmealDate.specs_name : '规格';

      // let leaseUnit = item.lease_set == '按月' ? '个月' : '天'
      var unit = spec.lease_title.indexOf('月') > -1 ? '月' : item.lease_set == '按天' ? '天' : '期';
      var str = '';
      if (spec.spec_value) {
        // str += `${specsName}:${spec.spec_value} / `

        //增加套餐租期列表总租金与买断金额显示后，调整单行输出内容尽量缩减
        var value_str = spec.spec_value.replace('下单请备注颜色', '');
        str += "".concat(specsName, ":").concat(value_str, " / ");
      }
      // str += `租期: ${spec.lease_time}${leaseUnit} / ${unit}租金: ${spec.lease_price}`

      //增加套餐租期列表总租金与买断金额显示后，调整单行输出内容尽量缩减
      str += "".concat(spec.lease_title, "/").concat(unit, ":").concat(spec.lease_price);
      return str;
    },
    setSpecId: function setSpecId(item) {
      this.form.spec_id = item.spec[0].id;
      console.log('this.form.spec_id', this.form.spec_id);
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          var params = (0, _objectSpread2.default)({}, _this2.form);
          console.log('submitParams', params);
          (0, _order.saveSetMeal)(params).then(function (res) {
            _this2.dialogVisible = false;
            _this2.$emit('getList', true);
          }).catch(function (error) {});
        } else {
          _this2.$message({
            message: "请检查表单错误",
            type: "error"
          });
          return false;
        }
      });
    }
  }
};
exports.default = _default;